export default __webpack_public_path__ + "ed5e204581c5e4b7c6e1fc8ee96aae31.png";